<input class="form-check-input" type="checkbox" [(ngModel)]="value" (ngModelChange)="toggle.emit($event)" [disabled]="disable" *ngIf="!showStatus" />

<div class="slider checkbox-big" *ngIf="showStatus">
	<input type="checkbox" id="" class="checkbox-toggle checkbox-toggle-pill" name="checkbox-toggle-pill" [(ngModel)]="value" />
	<label class="checkbox-toggle-label checkbox-toggle-pill-label" for="" (click)="toggleValue()">
		<span class="on">Enabled</span>
		<span class="off">Disabled</span>
	</label>
</div>
